import { Box, Grid } from "@material-ui/core";
import React, { useState } from "react";
import DeviceContainer from "../../containers/device/DeviceContainer";
import ListEkloksContainer from "../../containers/ekloks/ListEkloksContainer";
import List from "../ekloks/ListEkloks";
import Pair from "../ekloks/PairEklok";

const CustomerView = () => {
  const [openPair, setOpenPair] = useState(false);
  const [notices, setNotices] = useState(true);

  return (
    <>
      <Box p={2} mb="7%">
        <ListEkloksContainer>
          {({
            onRefreshAction,
            onConnectDevice,
            content,
            item,
            onCloseDevice,
            updateStatus,
            onUpdateRowsAndPages,
            date,
          }) => (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <List
                  onUpdateRowsAndPages={onUpdateRowsAndPages}
                  onRefreshAction={onRefreshAction}
                  onConnectDevice={onConnectDevice}
                  items={
                    content
                      ? content.map((eklok) => ({
                          ...eklok,
                          connected: updateStatus.find(
                            (item) => item.id === eklok.id,
                          )?.connected,
                        }))
                      : []
                  }
                  onAddAction={() => {
                    setOpenPair(true);
                    setNotices(true);
                  }}
                />
                {item ? (
                  <DeviceContainer
                    item={item}
                    onCloseDevice={onCloseDevice}
                    date={date}
                  />
                ) : null}
              </Grid>
            </Grid>
          )}
        </ListEkloksContainer>
      </Box>
      <Pair
        handleClose={() => setOpenPair(false)}
        open={openPair}
        setNotices={() => setNotices()}
        notices={notices}
      />
    </>
  );
};

export default CustomerView;
